// src/pages/Fliez/FolderManagement/components/CreateFolderModal.tsx
import React, { FC, useState } from 'react';
import Modal, { ModalBody, ModalHeader, ModalTitle, ModalFooter } from '../../../../components/bootstrap/Modal';
import Input from '../../../../components/bootstrap/forms/Input';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Button from '../../../../components/bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { createFolderWithImage } from '../../../../redux/Slice/FoldersSlice';
import img from '../../../../assets/img/user6.png';
import { ModeId } from '../../../../utils';


interface IProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onSuccess?: () => void;
}

const CreateFolderModal: FC<IProps> = ({ isOpen, setIsOpen, onSuccess }) => {
  const dispatch = useDispatch<any>();
  const { actionLoading } = useSelector((state: any) => state.folders);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('');
  const [avatarFil, setAvatarFile] = useState<any>(null);
  const userId = localStorage.getItem('Active_userId') || ""


  const handleCreate = async () => {
    if (!name) return;
    if (!ModeId) {
      console.error("Mode ID is required");
      return;
    }

    const folderData = {
      mode: ModeId,
      user: userId,
      Name: name,
      description,
      status: status || "active",
      metadata: {},
    };

    try {
      // 1) CREATE FOLDER
      await dispatch(
        createFolderWithImage({
          folderData,
          imageFile: avatarFil
        }) as any
      ).unwrap();

      // 3) RESET & CLOSE
      setName("");
      setDescription("");
      setStatus("");
      setAvatarFile(null);
      setIsOpen(false);

      onSuccess && onSuccess();
    } catch (err) {
      console.error("Error in folder creation/update:", err);
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <ModalHeader>
        <ModalTitle id="create-folder-modal-title">Create Folder</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className='row g-4 align-items-center' style={{}}>
          <FormGroup
            label='Add Folder Image *'
            style={{ display: 'flex', justifyContent: 'center' }}>
            <label htmlFor='avatarInput' style={{ margin: '47px 0px 0px -120px' }}>
              <div
                style={{
                  border: "1px solid gray",
                  width: "120px",
                  height: "120px",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "6px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={avatarFil ? URL.createObjectURL(avatarFil) : img}
                  alt="Avatar Preview"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <input
                  type="file"
                  accept="image/*"
                  id="avatarInput"
                  name="avatar"
                  style={{
                    opacity: 0,
                    position: "absolute",
                    cursor: "pointer",
                    top: 0,
                    left: 0
                  }}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.files && e.target.files[0]) {
                      const file = e.target.files[0];
                      setAvatarFile(file);
                      console.log("Selected file:", file);
                    }
                  }}
                />
              </div>
              <p className="mt-3 mb-2 text-center">Click on Image</p>
            </label>
          </FormGroup>
          <FormGroup id="folderName" label="Folder Name">
            <Input value={name} onChange={(e: any) => setName(e.target.value)} />
          </FormGroup>
          <FormGroup id="folderDescription" label="Folder Description">
            <Input value={description} onChange={(e: any) => setDescription(e.target.value)} />
          </FormGroup>
          <FormGroup id="folderStatus" label="Folder Status">
            <select
              className="form-select"
              value={status}
              onChange={(e: any) => setStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </FormGroup>
          {/* <FormGroup id="assignedUser" label="Folder User">
            <select
              className="form-select"
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              <option value="">Select User</option>
              {loading ? (
                <option disabled>Loading users...</option>
              ) : error ? (
                <option disabled>Error loading users</option>
              ) : (
                users?.data?.map((user: any) => (
                  <option key={user._id} value={user._id}>
                    {user.Name} ({user.email || 'No email'})
                  </option>
                ))
              )}
            </select>
          </FormGroup> */}
        </div>
      </ModalBody>
      <ModalFooter className='px-4 pb-4'>
        <Button
          color='primary'
          isLight
          onClick={() => handleCreate()}
          isDisable={actionLoading}
        >
          {actionLoading ? 'Creating...' : 'Create'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateFolderModal;
